import { jsx } from "react/jsx-runtime";
const BooleanCross = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: 4,
      height: 4,
      viewBox: "0 0 4 4",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2 1.99999L3.33333 3.33332M0.666664 3.33332L2 1.99999L0.666664 3.33332ZM2 1.99999L3.33333 0.666656L2 1.99999ZM2 1.99999L0.666664 0.666656L2 1.99999Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
};
const BooleanCheck = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: 6,
      height: 4,
      viewBox: "0 0 6 4",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5 0.666656L2.33333 3.33332L1 1.99999",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
};
const BooleanQuestion = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: 4,
      height: 6,
      viewBox: "0 0 4 6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0.5 1.65C0.711948 1.12566 1.28384 0.75 1.95607 0.75C2.80876 0.75 3.5 1.35442 3.5 2.1C3.5 2.72975 3.00686 3.25878 2.33982 3.40797C2.13047 3.45479 1.95607 3.65147 1.95607 3.9M1.95605 5.25H1.95991",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
};
export {
  BooleanCheck,
  BooleanCross,
  BooleanQuestion
};
